import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b511abd6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b511abd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b511abd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b511abd6')) {
      api.createRecord('b511abd6', component.options)
    } else {
      api.reload('b511abd6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b511abd6&scoped=true", function () {
      api.rerender('b511abd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/activitySetting/index.vue"
export default component.exports